<template>
  <RevButton
    class="w-full"
    data-test="submit-button"
    :disabled
    type="submit"
    variant="primary"
  >
    {{ submitButtonLabel }}
  </RevButton>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import type { StepId } from '~/api/reviews/types/GetReviewCollectionResponse'

import translations from './SubmitButton.translations'

const props = defineProps<{
  stepId: StepId | null
  disabled: boolean
}>()

const i18n = useI18n()

const submitButtonLabel = computed(() => {
  switch (props.stepId) {
    case 'main':
    case 'details':
    case 'product_comment':
      return i18n(translations.submitButtonContinue)
    case 'attachments':
      return i18n(translations.submitButtonUpload)

    default:
      return ''
  }
})
</script>
